import { message, Modal, Table, Space, Button, Select, Form, Input, Pagination, DatePicker, InputNumber, Switch, Tabs } from "antd";
import { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { getMonthStartEnd, formatNumber, formatDate, dayjsDate, getobjkeys, formatDate2, checkp, getAdmin } from '../../utils/functions'
import { PlusOutlined, EditOutlined, DeleteOutlined, DiffOutlined } from '@ant-design/icons';
import CustModal from "../../components/ShowModal";
import TbEditor from "../wlb/TbEditor";

function CustomerInfoPage() {
    const webPost = useWebPost();
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({});
    const [mfilters, setmFilters] = useState({});
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const pageSizeOptions = [10, 20, 50, 100, 500];

    const [form] = Form.useForm();
    const [editingRecord, setEditingRecord] = useState(null);
    const [config, setconfig] = useState(null);
    const [activeKey, setActiveKey] = useState('1');

    const loadingRef = useRef();
    useEffect(() => {
        const fetchItems = () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            try {
                const params = { page: currentPage, limit: pageSize, ...mfilters, ac: activeKey };
                if (mfilters.singleMonth) {
                    const { startTs, endTs } = getMonthStartEnd(mfilters.singleMonth);
                    params.startTs = startTs;
                    params.endTs = endTs;
                }
                webPost('customerinfo', params).then((response) => {
                    if (response && response.data) {
                        if (response.total < 1) {
                            message.info('未找到匹配数据');
                        }
                        setData(response.data);
                        setTotal(response.total);
                    }
                })
            } catch (e) {
                setData([]);
                setTotal(0);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        }
        fetchItems();
    }, [currentPage, pageSize, mfilters, freshData, activeKey]);
    const admin_info = getAdmin();
    const columns = [
        {
            title: '序号',
            dataIndex: 'xd',
            key: 'xd',
            width: 80,
            fixed: 'left',
            render: (text, record, rowIndex) => {
                return rowIndex + 1 + (currentPage - 1) * pageSize;
            },
        },
        { title: '年份', dataIndex: 'co_date', width: 120 },
        { title: '项目编号', dataIndex: 'sn', width: 150 },
        { title: '项目名称', dataIndex: 'xmmc', width: 200, fixed: 'left' },
        { title: '填报企业', dataIndex: 'com_tianbao', width: 160, },
        {
            title: '参与/中标/自营', dataIndex: 'type', width: 120, render: (v) =>
                <div
                    style={{
                        width: '100%',
                        whiteSpace: 'pre-wrap', // 解析换行符（\n）
                        wordBreak: 'break-all', // 超长字符换行
                        lineHeight: '1.4', // 行高适配
                        padding: '2px 0', // 内边距优化
                        overflow: 'hidden' // 配合ellipsis，超出宽度隐藏
                    }}
                >
                    {v || '-'} {/* 空值显示占位符 */}
                </div>
        },
        { title: '合同类型', dataIndex: 'co_type', width: 120, },
        { title: '业主名称', dataIndex: 'customer_name', width: 160, },
        { title: '业主性质', dataIndex: 'customer_nature', width: 120, },
        { title: '所属行业/专业', dataIndex: 'zylx', width: 140, },
        { title: '预计合同额(万元)', dataIndex: 'amount', width: 120, render: (v) => formatNumber(v / 10000) },
        { title: '实际合同额(万元)', dataIndex: 'sjamount', width: 120, render: (v) => formatNumber(v / 10000) },
        { title: '税率（%）', dataIndex: 'sl', width: 110, },
        { title: '项目地点', dataIndex: 'location', width: 220, },
        { title: '项目规模', dataIndex: 'xmgm', width: 100, },
        { title: '合同范围', dataIndex: 'htfw', width: 180, },
        { title: '投标月份', dataIndex: 'tbdate', width: 120, },
        { title: '业绩归属', dataIndex: 'ywname', width: 100, },
        { title: '填报人', dataIndex: 'creator', width: 100, },
        { title: '填报时间', dataIndex: 'create_time', width: 120, },
        { title: '客户名称/电话', dataIndex: 'wt_phone', width: 120, render:(v) => {
            if(!admin_info)return '';
            if(admin_info.type === 1 || checkp('all')) return v;
            return v.replace(/(1\d{2})\d{5}(\d{3})/g, '$1***$2');
        }},
        { title: '业主负责人/电话', dataIndex: 'customer_phone', width: 120, },
        { title: '项目负责人', dataIndex: 'xmfz', width: 120, },
        { title: '项目保险', dataIndex: 'xmbx', width: 120, },
        { title: '项目状态', dataIndex: 'xmzt', width: 100, },
        { title: '备注', dataIndex: 'ps', width: 100, },
        checkp(['gqjyaa', '1bb', 'cwxmxxm']) && {
            title: '操作',
            key: 'action',
            width: 160,
            fixed: 'right',
            render: (_, record) => {
                const rst = [];
                const status = Number(record.status);
                const mk = `qx_${record.id}_`;
                if(status === 10){
                    if(checkp('all')){
                        rst.push(<Button type="link"  key={`${mk}r`} onClick={() => submitTogd2(record.sn)}>移出</Button>)
                    }
                    return <div style={{ 'display': 'flex', 'flexDirection': 'column' }}>{rst}</div>;
                } 
                if (checkp('gqjyaa,cwxmxx')) {
                    rst.push(<Button key={`${mk}m`} type="link" icon={<EditOutlined />} onClick={() => showModal(record, 'edit')}>修改</Button>);
                    if (status === 0) rst.push(<Button type="link"  key={`${mk}t`} onClick={() => submitTosh(record.sn)}>提交审核</Button>)
                    // rst.push(<Button type="link" danger  onClick={() => handleDelete(record.sn)}>删除</Button>)
                }
                if(checkp('all')){
                    if (status === 2) rst.push(<Button type="link"  key={`${mk}g`} onClick={() => submitTogd(record.sn)}>归档</Button>);
                }
                if (checkp('1bb') && status === 2) {
                    if (!record.hastblist) rst.push(<Button type="link"  key={`${mk}q`} onClick={() => showModal2(record, "tbnew")} >
                        录入投标授权</Button>)
                }
                return <div style={{ 'display': 'flex', 'flexDirection': 'column' }}>{rst}</div>;

            },
        },
    ].filter(Boolean);

    const showModal = async (record = null, action) => {
        setEditingRecord(record);
        setModalVisible(action);
        if (config === null) {
            const res = await webPost('appc', {});
            if (res) setconfig(res);
        }
        if (record) {
            form.setFieldsValue({
                ...record, "co_date": dayjsDate(record.co_date),
                "tbdate": dayjsDate(record.tbdate), "isgsyj": record?.isgsyj === 1
            });
        } else {
            form.resetFields();
            form.setFieldValue('isgsyj', true);
        }
    };
    const showModal2 = (record = null, action) => {
        setEditingRecord({ "sn": record.sn, "xmmc": record.xmmc, "sh1ps2": record.type, "khname": record.wt_phone });
        setModalVisible(action);
    };

    const handleOk = async (ops) => {
        try {
            const values = await form.validateFields();
            values.isgsyj = values.isgsyj ? 1 : 0;
            values.co_date = formatDate2(values?.co_date);
            values.tbdate = formatDate2(values?.tbdate);
            const payload = editingRecord
                ? { ...values, id: editingRecord.id, "sn": editingRecord.sn }
                : values;
            if (ops.sh) payload.status = 1;
            // console.log(payload, getobjkeys(payload));

            const res = await webPost('customerinfo_save', payload);
            if (res) {
                message.success(editingRecord ? '更新成功' : '新增成功');
                saveSuccess();
            }
        } catch (err) {
            console.error('表单验证或提交错误:', err);
        }
    };
    const selectOptions = useMemo(() => {
        // 多层容错：确保config、str1存在且是字符串，且非空
        if (!config) {
            return { op1: [], op2: [], op3: [] };
        }
        const getop = (str) => {
            if (!str || typeof str !== "string") return [];
            return str.replace(/，/g, ',').replace(/、/g, ',').split(',').filter(item => item.trim())
                .map(item => ({
                    label: item.trim(),
                    value: item.trim()
                }));
        }
        const res = {
            op1: getop(config?.str1),
            op2: getop(config?.str2),
            op3: getop(config?.str3)
        };
        console.log(config, res);
        return res;
    }, [config]);
    // 删除记录
    const handleDelete = async (sn) => {
        Modal.confirm({
            title: '确认删除？',
            content: '此操作不可恢复',
            onOk: async () => {
                const res = await webPost('customerinfo_del', { sn });
                if (res) {
                    message.success('删除成功');
                    saveSuccess();
                } else {
                    message.error('删除失败');
                }
            },
        });
    };
    const submitTosh = async (sn) => {
        const res = await webPost('customerinfo_tsh', { sn });
        if (res) {
            saveSuccess();
        } else {
            message.error('提交失败');
        }
    }
    const submitTogd = async (sn) => {
        const res = await webPost('customerinfo_tgd', { sn });
        if (res) {
            saveSuccess();
        } else {
            message.error('提交失败');
        }
    }
    const submitTogd2 = async (sn) => {
        const res = await webPost('customerinfo_tgd2', { sn });
        if (res) {
            saveSuccess();
        } else {
            message.error('提交失败');
        }
    }
    const handleModalClose = () => {
        setModalVisible('');
        setEditingRecord(null);
    }
    const saveSuccess = () => {
        setfreshData(Math.random()); //强制刷新数据
        handleModalClose();
    };
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };
    return (
        <FullHeightLayout
            headerContent={
                <Space size="middle" wrap>
                    <Input value={filters.key} style={{ width: 240 }} onChange={(e) => setFilters(prev => ({ ...prev, key: e.target.value }))} 
                    placeholder="项目名称、项目编号、填报企业" />
                    <Input value={filters.key2} style={{ width: 240 }} onChange={(e) => setFilters(prev => ({ ...prev, key2: e.target.value }))} 
                    placeholder="业主名称、所属行业、业主负责人" />
                    <Input value={filters.key3} style={{ width: 240 }} onChange={(e) => setFilters(prev => ({ ...prev, key3: e.target.value }))} 
                    placeholder="业绩归属、项目负责人、客户名称" />
                    <Input value={filters.key1} style={{ width: 240 }} onChange={(e) => setFilters(prev => ({ ...prev, key1: e.target.value }))} 
                    placeholder="项目规模、合同范围、参与/中标/自营" />
                    <Button type="primary" onClick={() => { setmFilters({ ...filters }) }}>搜索</Button>
                    {checkp('gqjyaa') ? <Button icon={<PlusOutlined />} onClick={() => showModal(null, 'edit')}>新增客户</Button> : null}
                </Space>
            }
            bodyContent={
                <>
                    <Tabs activeKey={activeKey} onChange={setActiveKey}>
                        {/* <Tabs.TabPane key={'0'} tab='所有'></Tabs.TabPane> */}
                        <Tabs.TabPane key={'1'} tab='审核通过'></Tabs.TabPane>
                        <Tabs.TabPane key={'2'} tab='审核拒绝'></Tabs.TabPane>
                        <Tabs.TabPane key={'3'} tab='审核中'></Tabs.TabPane>
                        <Tabs.TabPane key={'4'} tab='草稿'></Tabs.TabPane>
                        <Tabs.TabPane key={'5'} tab='已归档'></Tabs.TabPane>
                    </Tabs>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="id"
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 2940,
                            y: 'calc(100vh - 300px)',
                        }}
                        tableLayout="fixed"
                        onRow={(record, index) => ({
                            onDoubleClick: (event) => {
                                if (checkp("ggfl,cwxmxx,cwxmxxm,2aa,cwkm,cwkmm,cwzh,cwzhm,cwhtsk,cwckpz,cwinv,cwfpd,zqdj,zqdjxg")) {
                                    // navigate('/htcx/' + record.sn);
                                    localStorage.setItem(`st_${record.sn}`, record?.status);
                                    window.open(`/htcx/${record.sn}`, '_blank');
                                }
                            },
                        })}
                    />
                    <TbEditor visible={modalVisible === 'tbnew'}
                        currentItem={editingRecord}
                        webPost={webPost}
                        onClose={handleModalClose}
                        onSaveSuccess={saveSuccess} />
                    <CustModal title='流转日志' open={modalVisible === 'log'} onCancel={handleModalClose} footer={false}>
                    </CustModal>
                    <CustModal
                        title={editingRecord ? '编辑项目信息' : '新增项目信息'}
                        open={modalVisible === 'edit'}
                        onOk={handleOk}
                        onCancel={handleModalClose}
                        okText="保存为草稿"
                        cancelText="取消"
                        footerAp={(<Button onClick={() => handleOk({ sh: 1 })}>保存并提交审核</Button>)}
                    >
                        <Form form={form} layout="vertical">
                            <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #e8e8e8' }}>
                                <h4 style={{ margin: '0 0 10 0' }}>基础信息</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
                                    <Form.Item
                                        name="co_date"
                                        label="合作日期"
                                        rules={[{ required: true, message: '请选择合作日期' }]}
                                    >
                                        <DatePicker
                                            style={{ width: '100%' }}
                                            placeholder="请选择合作日期"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="com_tianbao"
                                        label="填报企业"
                                        rules={[{ required: true, message: '请输入填报企业' }]}
                                    >
                                        <Input placeholder="请输入填报企业" maxLength={100} />
                                    </Form.Item>

                                    <Form.Item
                                        name="type"
                                        label="参与/中标/自营"
                                        rules={[{ required: true, message: '请填写参与/中标/自营' }]}
                                    >
                                        <Input.TextArea />
                                    </Form.Item>
                                </div>
                            </div>

                            {/* 合同信息组 */}
                            <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #e8e8e8' }}>
                                <h4 style={{ margin: '0 0 10 0' }}>合同信息</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>

                                    <Form.Item
                                        name="xmmc"
                                        label="项目名称"
                                        rules={[{ required: true, message: '请填写项目名称' }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        name="co_type"
                                        label="合同类型"
                                    >
                                        <Select placeholder="请选择" options={selectOptions.op1} />
                                    </Form.Item>

                                    <Form.Item
                                        name="amount"
                                        label="预计合同额"
                                    >
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            placeholder="请输入金额"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="sjamount"
                                        label="实际合同额"
                                    >
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            placeholder="请输入金额"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="sl"
                                        label="税率（%）"
                                    >
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            placeholder="请输入税率，不要输入%"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="tbdate"
                                        label="预计投标时间"
                                        rules={[{ required: true, message: '预计投标时间' }]}
                                    >
                                        <DatePicker style={{ width: '100%' }} />
                                    </Form.Item>

                                    <Form.Item
                                        name="xmzt"
                                        label="项目状态"
                                    >
                                        <Input />
                                    </Form.Item>
                                </div>
                            </div>

                            {/* 客户信息组 */}
                            <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #e8e8e8' }}>
                                <h4 style={{ margin: '0 0 10 0' }}>客户信息</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
                                    <Form.Item
                                        name="customer_name"
                                        label="业主名称"
                                        rules={[{ required: true, message: '请输入业主名称' }]}
                                    >
                                        <Input placeholder="请输入业主名称" maxLength={100} />
                                    </Form.Item>

                                    <Form.Item
                                        name="customer_nature"
                                        label="业主性质"
                                    >
                                        <Select placeholder="请选择" options={selectOptions.op2} />
                                    </Form.Item>

                                    <Form.Item
                                        name="location"
                                        label="项目地点"
                                        rules={[{ required: true, message: '请输入项目地点' }]}
                                    >
                                        <Input placeholder="请输入项目地点" maxLength={100} />
                                    </Form.Item>

                                    <Form.Item
                                        name="wt_phone"
                                        label="客户名称/电话"
                                        rules={[{ required: true, message: '请输入客户名称/电话' }]}
                                    >
                                        <Input placeholder="例如：张三 13800138000" maxLength={100} />
                                    </Form.Item>

                                    <Form.Item
                                        name="customer_phone"
                                        label="业主负责人/电话"
                                        rules={[{ required: true, message: '请输入业主负责人/电话' }]}
                                    >
                                        <Input placeholder="例如：李四 13900139000" maxLength={100} />
                                    </Form.Item>
                                    <Form.Item
                                        name="ywname"
                                        label="业绩归属"
                                        rules={[{ required: true, message: '请输入业绩归属' }]}
                                    >
                                        <Input placeholder="例如：李四" maxLength={100} />
                                    </Form.Item>

                                </div>
                            </div>

                            {/* 项目信息组 */}
                            <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #e8e8e8' }}>
                                <h4 style={{ margin: '0 0 10 0' }}>项目信息</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
                                    <Form.Item
                                        name="zylx"
                                        label="所属行业/专业"
                                    >
                                        <Select placeholder="请选择" options={selectOptions.op3} />
                                    </Form.Item>

                                    <Form.Item
                                        name="xmgm"
                                        label="项目规模"
                                    >
                                        <Input placeholder="请输入项目规模" maxLength={450} />
                                    </Form.Item>

                                    <Form.Item
                                        name="htfw"
                                        label="合同范围"
                                    >
                                        <Input placeholder="请输入合同范围" maxLength={200} />
                                    </Form.Item>

                                    <Form.Item
                                        name="xmfz"
                                        label="项目负责人"
                                    >
                                        <Input placeholder="请输入项目负责人" maxLength={50} />
                                    </Form.Item>
                                    <Form.Item
                                        name="xmbx"
                                        label="项目保险"
                                    >
                                        <Input placeholder="请输入项目保险" maxLength={100} />
                                    </Form.Item>
                                    <Form.Item
                                        name="xmjl"
                                        label="项目经理"
                                    >
                                        <Input placeholder="请输入项目经理" maxLength={50} />
                                    </Form.Item>
                                    <Form.Item
                                        name="isgsyj"
                                        label="是否公司业绩"
                                        valuePropName="checked"
                                    >
                                        <Switch checkedChildren="是" unCheckedChildren="不是" />
                                    </Form.Item>

                                </div>
                            </div>

                            {/* 备注信息 */}
                            <Form.Item
                                name="ps"
                                label="备注"
                            >
                                <Input.TextArea
                                    placeholder="请输入备注信息"
                                    rows={4}
                                    maxLength={500}
                                    showCount
                                />
                            </Form.Item>
                        </Form>
                    </CustModal>
                </>
            }
            footerContent={
                <div style={{
                    display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={total}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                        onChange={onPageChange}
                        pageSizeOptions={pageSizeOptions}
                    />
                </div>
            }
        />
    )
}


export default CustomerInfoPage;
